// items to be displayed in the admin menu
const adminMenuItems = [
    { path: '/admin/chats', label: 'Chats' },
    { path: '/admin/orders', label: 'Orders' },
    { path: '/admin/products-list', label: 'Products' },
    { path: '/admin/categories-list', label: 'Categories' },
    { path: '/admin/attributes-list', label: 'Attributes' },
    { path: '/admin/users', label: 'Users' },
    { path: '/admin/analytics', label: 'Analytics' },
    { path: '/admin/settings', label: 'Settings' },
  ];

export default adminMenuItems; 